// @flow
import config from 'Config';

const youtubeRegEx = new RegExp(
  'https://(?:youtu.be/|www.youtube.com/(?:watch\\?v=|embed/))([a-zA-Z0-9_-]+)',
);

const youkuRegEx = new RegExp(
  'https?://(?:player.youku.com/embed/|player.youku.com/player.php/sid/)([a-zA-Z0-9]+)',
);

function getYoutubeVideoUrl(url: string): ?string {
  const urlId = youtubeRegEx.exec(url);
  return urlId ? `https://www.youtube.com/embed/${urlId[1]}` : null;
}

function getYoukuVideoUrl(url: string): ?string {
  const urlId = youkuRegEx.exec(url);
  const clientId = config.get('youku.clientId');
  return urlId ? `https://player.youku.com/embed/${urlId[1]}?client_id=${clientId}` : null;
}

function getVideoUrl(url: string): ?string {
  return getYoutubeVideoUrl(url) || getYoukuVideoUrl(url);
}

function isVideoUrl(url: string): boolean {
  return youtubeRegEx.test(url) || youkuRegEx.test(url);
}

export { getVideoUrl, isVideoUrl };
